/**
 * Converte una riga di membership_tiers (dal DB via API) nel formato
 * display usato da MembershipSelection e Settings.
 *
 * @param {object} tier  - riga dal backend
 * @param {function} t   - funzione i18n (useTranslation)
 */
export function tierToDisplayPlan(tier, t) {
  const feePct = parseFloat(tier.fee_percentage) || 0;
  const feeVal = feePct * 100;
  const feeStr = Number.isInteger(feeVal) ? `${feeVal}%` : `${feeVal.toFixed(1)}%`;

  const sub = tier.subscription_monthly > 0
    ? t('membership.subscription_monthly', { amount: tier.subscription_monthly })
    : null;

  const assets = Array.isArray(tier.allowed_assets) ? tier.allowed_assets : [];
  const ASSET_LABELS = { ETF: 'ETF', STOCK: 'Stock', BOND: 'Bond', CRYPTO: 'Crypto' };
  const assetsLabel = assets.includes('ALL')
    ? t('membership.all_assets')
    : assets.map(a => ASSET_LABELS[a.toUpperCase()] || a).join(' + ');

  const portfoliosLabel = tier.max_portfolios == null
    ? t('membership.unlimited_portfolios')
    : `Max ${tier.max_portfolios}`;

  const maxLabel = `$${Number(tier.max_per_portfolio).toLocaleString('en-US')}`;
  const currencies = Array.isArray(tier.currencies) ? tier.currencies : ['USD'];

  return {
    key: tier.tier_key,
    name: tier.display_name,
    tagline: tier.tagline,
    color: tier.color,
    bg: `${tier.color}14`,
    border: `${tier.color}59`,
    popular: !!tier.is_popular,
    aiAdvisor: !!tier.ai_advisor,
    maxPortfolios: tier.max_portfolios,
    allowedAssets: assets,
    ...(tier.icon_type === 'img' ? { img: tier.icon_value } : { icon: tier.icon_value }),
    pricing: {
      value: feeStr,
      label: sub ? t('membership.pricing_label_sub') : t('membership.pricing_label'),
      sub,
    },
    features: [
      { label: t('membership.feature_assets'),           value: assetsLabel },
      { label: t('membership.feature_portfolios'),       value: portfoliosLabel },
      { label: t('membership.feature_ai'),               value: tier.ai_advisor ? '✓' : '✗', highlight: !!tier.ai_advisor, muted: !tier.ai_advisor },
      { label: t('membership.feature_currencies'),       value: currencies.join(' + ') },
      { label: t('membership.feature_max_per_portfolio'),value: maxLabel },
    ],
  };
}
